import React from "react";
import clsx from "clsx";
// import PropTypes from "prop-types";
import styles from "./styles/ProgressBar.module.css";

const ProgressBar = (props) => {
  const { value = 50, min = 0, max = 100 } = props;
  return (
    <div className={clsx("progress", styles.container)}>
      <div
        className={clsx("progress-bar", styles.progressBar)}
        role="progressbar"
        style={{ width: `${value}%` }}
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
      ></div>
    </div>
  );
};

/* required: display name */
ProgressBar.displayName = "ProgressBar";

/* required: props types */
ProgressBar.propTypes = {};

/* required: default props */
ProgressBar.defaultProps = {};

export { ProgressBar };
